import { useEffect, useState } from "react";
import { Mail, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Eyebrow } from "@/components/Bits";
import { useDialogs } from "@/components/GlobalDialogs";
import { getSettings } from "@/lib/api";

export default function Collaborate() {
  const { openCollaborate } = useDialogs();
  const [contact, setContact] = useState({ email: "", whatsapp: "" });

  useEffect(() => { getSettings().then((s) => setContact(s.contact || {})).catch(() => {}); }, []);

  const mailLink = contact.email ? `mailto:${contact.email}?subject=${encodeURIComponent("Collaborate with YTCA")}` : null;
  const waLink = contact.whatsapp ? `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent("Hi YTCA, I'd love to collaborate with you.")}` : null;

  return (
    <div>
      <section className="relative overflow-hidden border-b border-border noise">
        <div className="ytca-container py-16 sm:py-20">
          <Eyebrow>Collaborate With YTCA</Eyebrow>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-semibold tracking-tight sm:text-6xl">Let's build something together.</h1>
          <p className="mt-6 max-w-2xl text-lg text-muted-foreground">For artists, organisations, brands, educators and creative professionals. No forms to wrestle with — just reach out directly and we'll take it from there.</p>
        </div>
      </section>

      <div className="ytca-container py-14">
        <div className="grid gap-6 sm:grid-cols-2">
          <Card className="flex flex-col items-start rounded-2xl border-border bg-card p-8">
            <span className="rounded-xl bg-secondary p-3 text-primary"><Mail className="h-6 w-6" /></span>
            <h2 className="mt-4 font-display text-2xl font-semibold">Email Us</h2>
            <p className="mt-2 flex-1 text-muted-foreground">Tell us about your idea and we'll reply as soon as we can.</p>
            <Button asChild={!!mailLink} disabled={!mailLink} className="mt-5 rounded-full" data-testid="collab-page-email-button">
              {mailLink ? <a href={mailLink}><Mail className="h-4 w-4" /> {contact.email}</a> : <span>Email coming soon</span>}
            </Button>
          </Card>

          <Card className="flex flex-col items-start rounded-2xl border-border bg-card p-8">
            <span className="rounded-xl bg-secondary p-3 text-primary"><MessageCircle className="h-6 w-6" /></span>
            <h2 className="mt-4 font-display text-2xl font-semibold">Connect on WhatsApp</h2>
            <p className="mt-2 flex-1 text-muted-foreground">Start a quick conversation with the YTCA team.</p>
            <Button asChild={!!waLink} disabled={!waLink} className="mt-5 rounded-full" data-testid="collab-page-whatsapp-button">
              {waLink ? <a href={waLink} target="_blank" rel="noreferrer"><MessageCircle className="h-4 w-4" /> Message on WhatsApp</a> : <span>WhatsApp coming soon</span>}
            </Button>
          </Card>
        </div>

        <div className="mt-10 rounded-3xl border border-border bg-secondary/40 p-8 text-center">
          <p className="text-muted-foreground">Prefer to send the details in one go?</p>
          <Button onClick={openCollaborate} variant="outline" className="mt-4 rounded-full" data-testid="collab-page-form-button">Send a message</Button>
        </div>
      </div>
    </div>
  );
}
